import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderBatchInput } from './GetOrderBatchInput';
import { GetOrderBatchOutput } from './GetOrderBatchOutput';

export class GetOrderBatchService extends HttpServiceBase {

  handle = (input: GetOrderBatchInput): Promise<Result<GetOrderBatchOutput> | null> => {
    const promise = this.http.get<Result<GetOrderBatchOutput>>(`${this.baseUrlSislogApi}/v2/order/batch/${input.orderBatchId}`);
    return promise;
  }
}